import React, { useEffect, useState } from "react";
import Editor from "../../../elements/tiptap-editor/Editor.js";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import { postAddEdit, postDetails } from "../../../../services/postService";
import { useMutation, useQuery } from "@tanstack/react-query";
import Input from "../../../form/Input";
import { toast } from "react-toastify";
import { taxonomyList } from "../../../../services/taxonomyService";
import SelectSingleImage from "../../../form/SelectSingleImage";
import { useParams } from "react-router-dom";

const validation = {
  title: { required: true, message: "Question is required" },
  content: { required: true, message: "Answer is required" },
};

const ManageTestimonial = ({ getResponse = () => {}, close = () => {}, data }) => {
  const [coverMedia, setCoverMedia] = useState({});
  const { values, handleChange, handleSubmit, errors, setFieldsValue, resetField, formValidate } = useForm({
    validationRules: validation,
  });
  const params = useParams();
  const id = data?.uid;

  const { data: details } = useQuery({
    queryKey: ["post-details", id],
    queryFn: async () => {
      const res = await postDetails({ id: id });
      return res?.data;
    },
    enabled: !!id,
  });

  useEffect(() => {
    console.log(coverMedia);
  }, [coverMedia]);

  useEffect(() => {
    if (details?._id) {
      setFieldsValue(details);
      setCoverMedia(details?.coverMedia);
    }
  }, [details]);

  useEffect(() => {
    console.log(coverMedia);
  }, [coverMedia]);

  const {
    mutate,
    error,
    isLoading: detailsLoading,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await postAddEdit({
        ...val,
        type: "testimonial",
        coverMedia: coverMedia ? coverMedia?._id : null,
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-4 gap-x-4 gap-y-4 m-4">
        <div className="relative col-span-3">
          <Input
            label="Title"
            inputPlaceholder="title"
            onChange={handleChange}
            inputName={"title"}
            required={false}
            value={values?.title}
            {...formValidate(errors, "title")}
          />
        </div>
        {/* <div className="relative col-span-1">
          <div className=" rounded-lg p-2 space-y-2 justify-end">
            <SelectSingleImage
              label="Upload Image"
              size="md"
              value={testimonialImage}
              onChange={(img) => setTestimonialImage(img)}
              onRemove={() => setTestimonialImage(null)}
            />
          </div>
        </div> */}
        <div className="col-span-1 space-y-6">
          <div className="border border-gray-300 rounded-lg p-2 space-y-2">
            <SelectSingleImage
              label="Upload Image"
              size="md"
              value={coverMedia}
              onChange={(img) => setCoverMedia(img)}
              onRemove={() => setCoverMedia(null)}
            />
          </div>
        </div>

        <div className="relative col-span-4">
          <Editor
            label="Content"
            height={200}
            placeholder="content"
            value={values?.content}
            onChange={(val) =>
              handleChange({
                target: { name: "content", value: val },
              })
            }
            {...formValidate(errors, "content")}
          />
        </div>
      </div>
      <div className="pt-3 p-6 flex justify-end">
        <Button
          buttonType="submit"
          buttonClasses={"min-w-36"}
          buttonLabel={data?._id ? "Update" : "Save"}
          {...((isLoading || detailsLoading) && {
            loading: true,
            buttonIconPosition: "left",
            isDisable: true,
          })}
        />
      </div>
    </form>
  );
};

export default ManageTestimonial;
